import { animated, SpringValue } from '@react-spring/web';
import classNames from 'classnames';
import React from 'react';
import { Journey } from 'src/common/interfaces/journey.interface';
import { NeuePlayerJourneyView } from '../neue-player/journey-view';

type Props = {
  show: boolean;
  opacity: SpringValue<number>;
  readyToRender: boolean;
  journey?: Journey;
};

export const PlayerPreview = ({ show, opacity, journey, readyToRender }: Props) => {
  if (!journey) {
    return null;
  }

  return (
    <animated.div
      className={classNames('bg-neue-canvas-bg text-neue-journey-bg fixed inset-0 z-neue-player-preview', {
        'pointer-events-none': !show,
      })}
      style={{ opacity }}
    >
      {show && <NeuePlayerJourneyView journey={readyToRender ? journey : null} />}
    </animated.div>
  );
};
